export async function getQuestions(id) {
  try {
    const data = await fetch('/api/common/questions?id=' + id).then(res => res.json());
    return {questions: data.payload, category: data.category}
  } catch (error) {
    return []
  }
}



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/actions.js